import { Link } from 'react-router-dom';
import { siteConfig, navLinks } from '@/mocks/site-config';

export default function Footer() {
  return (
    <footer className="bg-secondary-950">
      <div className="px-4 md:px-6 py-14 md:py-16">
        <div className="mb-10">
          <h2 className="font-heading text-5xl md:text-7xl font-black text-background-50 tracking-wide">
            {siteConfig.name}
          </h2>
        </div>

        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-2/5">
            <p className="text-foreground-200 text-sm leading-relaxed max-w-md">
              {siteConfig.description}
              每天24小时不间断追踪网络热点，为吃瓜群众提供最新、最全、最劲爆的独家爆料内容。
            </p>
            <div className="flex gap-4 mt-6">
              <a href="#" className="w-10 h-10 rounded-full border border-foreground-300/40 flex items-center justify-center text-foreground-200 hover:text-primary-400 hover:border-primary-400 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-foreground-300/40 flex items-center justify-center text-foreground-200 hover:text-primary-400 hover:border-primary-400 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-foreground-300/40 flex items-center justify-center text-foreground-200 hover:text-primary-400 hover:border-primary-400 transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-lg" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-foreground-300/40 flex items-center justify-center text-foreground-200 hover:text-primary-400 hover:border-primary-400 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-lg" />
              </a>
            </div>
          </div>

          <div className="lg:w-2/5 space-y-8">
            <div>
              <h4 className="font-label text-xs font-semibold text-background-50 uppercase tracking-widest mb-2">地址</h4>
              <p className="text-foreground-300 text-sm leading-relaxed">{siteConfig.address}</p>
            </div>
            <div>
              <h4 className="font-label text-xs font-semibold text-background-50 uppercase tracking-widest mb-2">电话</h4>
              <p className="text-foreground-300 text-sm">{siteConfig.phone}</p>
            </div>
            <div>
              <h4 className="font-label text-xs font-semibold text-background-50 uppercase tracking-widest mb-2">邮箱</h4>
              <p className="text-foreground-300 text-sm">{siteConfig.email}</p>
            </div>
          </div>

          <div className="lg:w-1/5">
            <img
              src="https://readdy.ai/api/search-image?query=Dramatic%20editorial%20photography%20of%20modern%20city%20at%20night%20with%20neon%20highlights%2C%20dark%20moody%20atmosphere%2C%20urban%20landscape%2C%20warm%20amber%20and%20deep%20shadow%20tones%2C%20stylish%20contemporary%20aesthetic&width=300&height=400&seq=footer-portrait&orientation=portrait"
              alt="吃瓜官网品牌形象"
              title="吃瓜官网 · 独家爆料平台"
              className="w-full h-48 object-cover rounded-lg"
            />
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-foreground-300/20 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-400 text-xs">{siteConfig.copyright}</p>
          <div className="flex items-center gap-6">
            {navLinks.slice(0, 4).map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className="text-foreground-400 text-xs hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}